import react from '../../assets/reactjs_tool.png'
import html from '../../assets/html_tool.png'
import css from '../../assets/css_tool.png'
import mongo from '../../assets/mongodb_tool.png'
import express from '../../assets/express_tool.png'
import bootstrap from '../../assets/bootstrap_tool.png'
import git from '../../assets/git_tool.png'
import illustrator from '../../assets/illustrator_tool.png'
import photoshop from '../../assets/photoshop_tool.png'
import figma from '../../assets/figma_tool.png'
import xd from '../../assets/xd_tool.png'
import tailwind from '../../assets/tailwind_tool.png'
import material from '../../assets/material_tool.png'
import chakra from '../../assets/chakra_tool.png'
import premiere from '../../assets/premiere_tool.png'
import ad from '../../assets/AD_effects_tools.png'
import three from '../../assets/three_tool.png'
import ejs from '../../assets/ejs.png'
export const data = [
    
    {
        id:1,
        image:react,
        title:"React",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:html,
        title:"HTML",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:css,
        title:"CSS",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:mongo,
        title:"MongoDB",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:express,
        title:"Express JS",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:three,
        title:"Three JS",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:figma,
        title:"Figma",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:bootstrap,
        title:"Bootstrap",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:illustrator,
        title:"Illustrator",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:git,
        title:"Git",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:photoshop,
        title:"Photoshop",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:premiere,
        title:"Premiere Pro",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:xd,
        title:"Adobe XD",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:ad,
        title:"After Effects",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:tailwind,
        title:"Tailwind CSS",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:material,
        title:"Material UI",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:chakra,
        title:"Chakra UI",
        url:"www.google.co.in"
    },
    {
        id:1,
        image:ejs,
        title:"EJS",
        url:"www.google.co.in"
    }
]